import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=5455936e&scoped=true&"
import script from "./Notificaciones.vue?vue&type=script&lang=ts&"
export * from "./Notificaciones.vue?vue&type=script&lang=ts&"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=5455936e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455936e",
  null
  
)

export default component.exports